import AIGeneratedFormPreviewWebview from '@/modules/aiChat/createForm/AIGeneratedFormPreviewWebview'
import { Stack, useLocalSearchParams } from 'expo-router'
import { Platform, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

export default function AICreateFormPreviewPage() {
  const insets = useSafeAreaInsets()
  const { url } = useLocalSearchParams<{ url: string }>()

  return (
    <View className="flex-1" style={Platform.OS === 'android' ? { paddingBottom: insets.bottom } : undefined}>
      <Stack.Screen
        options={{
          headerLargeTitle: false,
        }}
      />
      <AIGeneratedFormPreviewWebview url={url} />
    </View>
  )
}
